<template>
  <div class="largeFormContainer">
    <h1 class="title is-1" v-if="$route.params.person_id">{{ $t("People.edit-person") }}</h1>
    <h1 class="title is-1" v-else-if="!modal">{{ $t("PersonForm.new-person") }}</h1>
    <div class="p-fluid p-formgrid p-grid p-my-2">
      <div class="p-field p-col-6">
        <InputText
          id="firstname"
          :placeholder="$t('PersonForm.first-name')"
          autofocus
          v-model="person.first"
          type="text"
        />
      </div>
      <div class="p-field p-col-6">
        <InputText id="lastname" :placeholder="$t('PersonForm.last-name')" v-model="person.last" type="text" />
      </div>
      <div class="p-field p-col-6">
        <div>{{ $t("PersonForm.person-roles") }}</div>
        <div class="p-field-checkbox">
          <Checkbox name="iscoach" :binary="true" v-model="person.is_coach" />
          <label for="iscoach"> {{ $t("coach") }}</label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="isplayer" :binary="true" v-model="person.is_player" />
          <label for="isplayer"> {{ $t("player") }}</label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="isumpire" :binary="true" v-model="person.is_umpire" />
          <label for="isumpire"> {{ $t("umpire") }}</label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="isstaff" :binary="true" v-model="person.is_staff" />
          <label for="isstaff"> {{ $t("staff") }}</label>
        </div>
      </div>
      <div class="p-field p-col-6">
        <div>{{ $t("PersonFrom.contact-information") }}</div>
        <span class="p-input-icon-left">
          <i class="pi pi-phone" />
          <InputText
            class="p-my-2"
            :placeholder="$t('PersonFrom.home-phone')"
            v-model.trim="person.address.phone_primary"
            type="phone"
          />
        </span>
        <span class="p-input-icon-left">
          <i class="pi pi-phone" />
          <InputText
            class="p-my-2"
            :placeholder="$t('PersonFrom.work-phone')"
            v-model.trim="person.address.phone_secondary"
            type="phone"
          />
        </span>
        <span class="p-input-icon-left">
          <i class="pi pi-envelope" />
          <InputText
            class="p-my-2"
            :placeholder="$t('PersonFrom.primary-email')"
            v-model="person.address.email_primary"
            type="email"
          />
        </span>
        <span class="p-input-icon-left">
          <i class="pi pi-envelope" />
          <InputText
            class="p-my-2"
            :placeholder="$t('PersonFrom.secondary-email')"
            v-model="person.address.email_secondary"
            type="email"
          />
        </span>
      </div>
    </div>
    <div class="p-text-center p-mt-5">
      <Button @click="savePerson" class="p-button-lg" :label="$t('Button.save')" :disabled="!isValid" />
      <br /><br />
      <Button @click="goRouter('/')" class="p-button p-button-text" :label="$t('Button.cancel')" />
    </div>

    <div class="p-text-center p-mt-5" v-if="person && person.id">
      <v-popover>
        <Button class="p-button p-button-danger p-button-text" :label="$t('Button.delete-person')" />
        <template slot="popover">
          <div class="popover-wrapper">
            <div class="popover-title">{{ $t("confirm-delete-person.title") }}</div>
            <div class="popover-text">
              {{ $t("confirm-delete-person.text") }}
            </div>
            <div class="popover-actions">
              <Button
                class="p-button p-button-danger p-button-text"
                :label="$t('Button.delete-person')"
                @click="deletePerson"
              />
              <Button v-close-popover class="p-button p-button-text" :label="$t('Button.cancel')" />
            </div>
          </div>
        </template>
      </v-popover>
    </div>
    <div v-else></div>
    <div class="mt-3">
      <PapaParse @save="doBulk" item="person"></PapaParse>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: ["modal", "role"],
  data() {
    return {
      person: {
        first: "",
        last: "",
        season_id: this.$store.getters.currentSeason.id,
        is_staff: this.role == "staff",
        is_umpire: this.role == "umpire",
        is_player: this.role == "player",
        is_coach: this.role == "coach",
        address: {
          season_id: this.$store.getters.currentSeason.id,
          line_1: "",
          line_2: "",
          city: "",
          state: "",
          zip: "",
          lat: "",
          lon: "",
          link: "",
          phone_primary: "",
          phone_secondary: "",
          email_primary: "",
          email_secondary: "",
        },
      },
    };
  },
  computed: {
    isValid() {
      return !!this.person.first && !!this.person.last;
    },
  },
  methods: {
    doBulk(links) {
      console.log("DoBulk", links);
      api
        .createBulkPeople(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.created-people-from-csv"));
          this.$store.dispatch("getLeagueInformation");
          this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(error);
        });
    },
    updateColor(color) {
      this.person.color = color.hex;
    },
    deletePerson() {
      api
        .deletePerson(this.person.id)
        .then(response => {
          this.makeToast("info", this.$t("Toast.deleted-person"));
          this.$store.dispatch("getLeagueInformation");
          this.goRouter(`/`);
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          alert(this.$t("Toast.error.could-not-delete-person"));
          this.refreshLeagueInformation();
        });
    },
    savePerson() {
      this.person.first = this.removeBadCharacters(this.person.first);
      this.person.last = this.removeBadCharacters(this.person.last);
      if (this.person.id) {
        api
          .updatePerson(this.person)
          .then(response => {
            console.log("update response", response);
            this.makeToast("info", this.$t("Toast.updated-person"));
            this.$store.dispatch("getLeagueInformation");
            if (this.modal) {
              this.$emit("done", response.data);
            } else {
              this.goRouter(`/people/` + response.data.id);
            }
          })
          .catch(error => {
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      } else {
        api
          .createPerson(this.person)
          .then(response => {
            this.makeToast("success", this.$t("Toast.created-person"));
            this.$store.dispatch("getLeagueInformation");
            if (this.modal) {
              this.$emit("done", response.data);
            } else {
              this.goRouter(`/people/` + response.data.id);
            }
          })
          .catch(error => {
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      }
    },
  },
  created() {
    if (this.$route.params.person_id) {
      api.getPerson(this.$route.params.person_id, this.$store.getters.currentSeason.id).then(response => {
        console.log("Got Person", response.data);
        this.person = response.data;
      });
    }
  }
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
</style>
